import React, { Component } from "react";
import { connect } from "react-redux";
import { RefreshTable } from "../../../redux/actions/Cart.Action";
import CartTable from "../../Components/Cart/CartTable";
class TableDetails extends Component {
  render() {
    return (
      <div className="card mb-0">
        <div className="card-header">
          <h4>Tables</h4>
          <span
            className="btn b-0 p-0 m-0 fs-20 material-icons-outlined"
            onClick={() => this.props.RefreshTable()}
          >
            sync
          </span>
        </div>
        <div className="card-body">
          <CartTable waiter={true} />
        </div>
      </div>
    );
  }
}

export default connect(() => ({}), { RefreshTable })(TableDetails);
